export default __webpack_public_path__ + "static/media/ic_settings_white.4f67d0d4.svg";